const tr = {
  medical_records: {
    attributes: {
      doctor: 'Médico responsável',
      doctor_id: 'Médico responsável',
      user_id: 'Paciente',
      religion: 'Religião',
      health_insurance: 'Convênio',
      medical_plan: 'Plano',
      medical_number: 'N° Carteirinha',
      medication_in_use: 'Medicação em uso',
      additional_information: 'Informações adicionais',
      weight: 'Peso (Kg)',
      height: 'Altura (m)',
      rg: 'Rg',
      profession: 'Profissão',
      naturalness: 'Naturalidade',
      marital_status: 'Estado civil',
      father_name: 'Nome do pai',
      mother_name: 'Nome da mãe',
      family_contact: 'Contato da família',
      kinship: 'Parentesco',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      docs: 'Documentos do Paciente'
    },
    extras: {
      user_data: 'Dados do paciente',
    },
  }
};

export default tr;
